// extracted by mini-css-extract-plugin
export default {"form":"PrintForm_form__FHkjt","formItem":"PrintForm_formItem__M7FEp","tablePrint":"PrintForm_tablePrint__pTjHD"};